/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_S2Inputs */

const en_tut_akses_s2 = /** @type {(inputs: Tut_Akses_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For division mode, choose the **Tim terkait**. For manual invitations, add people one by one under **Akses anggota**.`)
};

const id_tut_akses_s2 = /** @type {(inputs: Tut_Akses_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk mode divisi, pilih **Tim terkait**. Untuk undangan manual, tambahkan orangnya satu per satu lewat **Akses anggota**.`)
};

/**
* | output |
* | --- |
* | "For division mode, choose the **Tim terkait**. For manual invitations, add people one by one under **Akses anggota**." |
*
* @param {Tut_Akses_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_s2 = /** @type {((inputs?: Tut_Akses_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_s2(inputs)
	return en_tut_akses_s2(inputs)
});